/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-23 16:25:54
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-06-03 11:04:52
 * @FilePath: /unifyxp-v2-store-portal/src/pages/FileDetail/Components/Input/index.tsx
 */
import React, { useState, useRef } from 'react';
import { useClickAway } from 'ahooks';

import { Icon } from '@/src/tools/icon';
import { Input } from '@/src/components/Antd';

import styles from './style.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
function EditInput({ value, onChange }) {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const ref = useRef(null);
  const [edit, setEdit] = useState(false);

  useClickAway(() => setEdit(false), ref);
  return (
    <span className={styles.container} ref={ref}>
      {edit ? (
        <Input
          fullyControlledFilter={(value) => value}
          value={value}
          onChange={onChange}
          className={styles.input}
        />
      ) : (
        <span className={styles.value}>{value}</span>
      )}
      <span className={styles.edit} onClick={() => setEdit(true)}>
        <Icon type='iconedit' className={styles.icon} />
        <span>{getI18n('general.edit')}</span>
      </span>
    </span>
  );
}

export default EditInput;
